<section>
  <mat-expansion-panel class="validators-panel" [expanded]="rulesExpanded" (opened)="rulesExpanded = true" (closed)="rulesExpanded = false">
    <mat-expansion-panel-header>
      <mat-panel-title>{{'contentTypes.schemaRulesTitle' | translate}}</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="validators-header">
      <p>{{'taskTemplates.rulesIntro' | translate}}</p>

      <button mat-button [matMenuTriggerFor]="rulesTypes" class="my-3 secondary-gray-button validator-add-button" [disabled]="!tasktemplateUserRights_update">
        <mat-icon>add_circle</mat-icon> {{'taskTemplates.addRule' | translate}}
      </button>
      <mat-menu #rulesTypes="matMenu" xPosition="before" yPosition="below">
        @for (element of selectableRuleTypes; track element) {
          <button mat-menu-item (click)="addRule(element.type)" [disabled]="!element.allowedFields.includes(fieldType)">
            <mat-icon>{{element.icon}}</mat-icon>
            <span>{{element.translation | translate}}</span>
          </button>
        }
      </mat-menu>
    </div>

    @if (!validationAll?.length) {
      <div class="validators-empty">
        <mat-icon>rule</mat-icon>
        <div>
          <strong>{{'contentTypes.noSchemaRules' | translate}}</strong>
          <p>{{'taskTemplates.noRules' | translate}}</p>
        </div>
      </div>
    }

    @if (validationAll?.length) {
      <div class="validators-list">
        @for (rule of validationAll; track rule; let index = $index) {
          <article class="validator-card">
            <div class="validator-card-main">
              <span class="validator-icon"><mat-icon>{{getRuleIcon(rule.type)}}</mat-icon></span>
              <div>
                <strong>{{getRuleLabel(rule.type)}}</strong>
                <p>{{getRuleSummary(rule)}}</p>
                @if (rule.errorMessage) {
                  <p>{{'taskTemplates.rules.errorMessage_description' | translate}}: {{rule.errorMessage}}</p>
                }
              </div>
            </div>

            <div class="validator-actions">
              <button mat-icon-button [attr.aria-label]="'contentTypes.editSchemaRule' | translate" [disabled]="!tasktemplateUserRights_update" (click)="editRule(rule, index)">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
              </button>
              <button mat-icon-button [attr.aria-label]="'contentTypes.deleteSchemaRule' | translate" [disabled]="!tasktemplateUserRights_delete" (click)="deleteRule(rule, index)">
                <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
              </button>
            </div>
          </article>
        }
      </div>
    }
  </mat-expansion-panel>
</section>
